export const TEMPLATE_ID_OVERRIDE_TEST_IDS = {
    root: 'dev-panel-template-id-override',
    input: 'dev-panel-template-id-override-input',
    apply: 'dev-panel-template-id-override-apply',
    clear: 'dev-panel-template-id-override-clear',
    error: 'dev-panel-template-id-override-error',
} as const;
